import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { clearEditor } from '../RichTextEditor.utils';

const EditablePlugin = ({
  editable,
  clearContentsOnDisable = false,
}: {
  editable: boolean;
  clearContentsOnDisable?: boolean;
}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(editable);

    if (!editable && clearContentsOnDisable) {
      clearEditor(editor);
    }
  }, [editor, editable, clearContentsOnDisable]);

  return null;
};

export default EditablePlugin;
